module.exports = __webpack_public_path__ + "static/img/papuga.67c1e1ed.jpg";